export const contestAnalysisFilters = [
    {
      text: "Leetcode",
      domainFilter: "leetcode",
      id: 1,
      lock: false,
    },
    {
      text: "Codeforces",
      domainFilter: "codeforces",
      id: 2,
      lock: true,
    },
    {
      text: "Unstop",
      domainFilter: "Unstop",
      id: 5,
      lock: true,
    },
    {
      text: "Codechef",
      domainFilter: "codechef",
      id: 3,
      lock: true,
    },
    {
      text: "Hackerrank",
      domainFilter: "hackerrank",
      id: 4,
      lock: true,
    },
  ];
  